/**
 * Recognition certificates — the contract between the API and the portal.
 *
 * Two shapes that are easy to confuse, so they are named for the difference:
 *
 *   `VolunteerCertificateSummary` is a LIVE calculation. It answers "what would
 *   a certificate for this person say if we issued one now", and it changes
 *   every time attendance is approved. This is what the admin table lists.
 *
 *   `Certificate` is a FROZEN record. It answers "what did the certificate we
 *   already sent say", and it never changes. See migration 034 for why.
 *
 * The gap between the two is the feature: an admin looks at the live figure,
 * decides, and issuing copies it into a record that then stops moving.
 */
/**
 * How many volunteers one request may issue to.
 *
 * A cap rather than a page size: every certificate is an email somebody
 * receives, so the blast radius of a mis-click is bounded by construction
 * rather than by the admin noticing. Shared so the portal can disable the
 * button at the same number the API refuses at, instead of discovering it.
 */
export const MAX_CERTIFICATES_PER_REQUEST = 50;
/**
 * How long a custom certificate's text may be.
 *
 * Shared so the portal's textarea disables at the exact length the API
 * refuses at, instead of a 422 an admin discovers after writing three
 * paragraphs. Sized to what `drawCustomCitation` (`certificate-pdf.ts`) can
 * lay out on the page without visibly shrinking the document's other
 * proportions — a citation this long already reads as a short paragraph, not
 * a sentence.
 */
export const CUSTOM_CERTIFICATE_TEXT_MAX_LENGTH = 600;
//# sourceMappingURL=certificates.js.map